<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="contasreceber"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [10, 50, 100, 200] }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
        </v-toolbar>
      </template>
      <template v-slot:item.nome_cliente="{ item }">
        <span class="caption">{{ strDocumento(item.cpf_cnpj, item.tipo_cliente) }}</span>
        <br />
        {{ item.nome_cliente }}
      </template>

      <template v-slot:item.data_vencimento="{ item }">
        <span class="caption">{{ dataBR(item.data_vencimento) }}</span>
      </template>

      <template v-slot:item.valor_receber="{ item }">
        <span class="caption">{{ build.money(item.valor_receber) }}</span>
      </template>

      <template v-slot:item.situacao="{ item }">
        <span class="caption">{{ infoSituacao[item.situacao] }}</span>
      </template>

      <template v-slot:item.data_baixa="{ item }">
        <span class="caption">{{ dataBR(item.data_baixa) }}</span>
      </template>

      <template v-slot:item.comissao_receber="{ item }">
        <span class="caption">{{ build.money(item.comissao_receber) }}</span>
      </template>
      <template v-slot:item.bv="{ item }">
        <span class="caption">{{ build.money(item.bv) }}</span>
      </template>

    </v-data-table>
  </v-container>
</template>

<script>
import DatatableFilters from "../components/DatatableFilters";
import { build } from "../lib/masks";
export default {
  components: {
    DatatableFilters,
  },
  data() {
    return {
      headers: [
        { text: "Título", value: "documento" },
        { text: "Cliente", value: "nome_cliente" },
        { text: "Data Vencimento", value: "data_vencimento", align: "center" },
        {
          text: "Situação",
          value: "situacao",
          align: "center",
        },
        { text: "Data Baixa", value: "data_baixa", align: "center" },
        { text: "Valor", value: "valor_receber" },
        { text: "BV", value: "bv" },
        { text: "Comissão", value: "comissao_receber" },
      ],
      filters: [
        {
          name: "id_empresa",
          label: "Empresa",
          type: "select",
          options: [],
        },
        {
          name: "id_cliente",
          label: "Cliente",
          type: "select",
          multiple: false,
          options: [],
        },
        {
          name: "situacao",
          label: "Situação",
          type: "select",
          multiple: false,
          options: [
            {
              value: "DG",
              text: "Digitação",
            },
            {
              value: "AB",
              text: "Aberto",
            },
            { value: "PG", text: "Pago" },
            {
              value: "CA",
              text: "Cancelado",
            },
          ],
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.contasrecebervendedor") || `{}`
      ),
      loading: true,
      menu: [],
      infoSituacao: {
        DG: "Digitação",
        AB: "Aberto",
        PG: "Pago",
        CA: "Cancelado",
      },
      contasreceber: [],
      build
    };
  },
  methods: {
    async listar() {
      this.loading = true;
      try {

        const relatorio = await this.$store.dispatch("relatorio/contasReceberVendedor", {
          ...this.filtrosAtivos
        });
        this.contasreceber = relatorio.contas;
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de contas a receber",
        });
      }
      this.loading = false;
    },
    strDocumento(nro, tipo_cliente) {
      try {
        if (tipo_cliente === "F") {
          return build.cpf(nro);
        } else {
          return build.cnpj(nro);
        }
      } catch (err) {
        return "*Cliente Excluído*";
      }
    },
    dataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.substr(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    money: build.money
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.contasrecebervendedor", JSON.stringify(val));
      this.listar(this.opts);
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Acompanhamento de comissões",
    });

    this.$store.dispatch("empresa/listar", {}).then((empresas) => {
      this.filters.find((f) => f.name === "id_empresa").options =
        empresas.data.map((e) => ({
          text: e.nome_fantasia,
          value: e.id,
        }));
    });

    this.$store.dispatch("cliente/listar", {}).then((formas) => {
      this.filters.find((f) => f.name === "id_cliente").options =
        formas.data.clientes.map((f) => ({
          text: `${f.nome} - ${f.razao_social}`,
          value: f.id,
        }));
    });

    this.listar();
  },
};
</script>
